import { createContext } from 'react';

import { TripContextType } from './types';

export const TripContext = createContext<TripContextType | null>(null);
TripContext.displayName = 'TripContext';
